import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { motion } from "framer-motion";

const ProductAdd = () => {


  const menus = ["AKT STEEL", "AKT TRADING", "AKT AUTOMOTIVE"];
  const submenus = {
    "AKT STEEL": ["STEEL STRUCTURE"],
    "AKT TRADING": ["SEALENTS", "Aircraft Maintenance (RTV)", "ADHESIVES", "ROOF COATINGS"],
    "AKT AUTOMOTIVE": ["AKT AUTOMOTIVE", "TIRE-REINFORCEMENT"],
  };

  const [step, setStep] = useState(1);
  const [selectecatogery, setSelectedCatogery] = useState("");
  const [selectedSubcatogery, setSelectedSubCatogery] = useState("");
  const [title, setTitle] = useState([""]); // Change from string to array
  const [descriptions, setDescriptions] = useState([""]);
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);  // ✅ Fix setLoading not defined
  const [successMsg, setSuccessMsg] = useState("");  // ✅ Fix setSuccessMsg not defined
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [country, setSelectedCountry] = useState("");
  const [performance, setPerformance] = useState([""]);
  const [productVideo, setProductVideo] = useState([""]);
  const [finishes, setFinishes] = useState([""]);
  const [availableSizes, setAvailableSizes] = useState([""]);
  const [pdfName] = useState('');
  const [pdfFile, setPdfFile] = useState([{ name: "", file: null }]);
  const [advantages, setAdvantages] = useState([""]);



  const handleNextStep = () => {
    if (step === 1 && !selectecatogery) return setError("* Please Select a Category.");
    if (step === 2 && !selectedSubcatogery) return setError("* Please Select a Subcategory.");
    if (step === 3 && !image) return setError("* Please Upload Product image.");
    if (step === 4 && !country) return setError("* Please Select a Country.");
    if (step === 5 && (!title[0] || title[0].trim() === "" || descriptions[0].trim() === "")) {
      return setError("* Product Title and Description 1 are Required.");
    };
    if (step === 6 && (!performance[0] || performance[0].trim() === "")) {
      return setError("* Performance field is required.");
    }
    if (step === 7 && (!productVideo[0] || productVideo[0].trim() === "")) {
      return setError("* Product Video field is required.");
    }
    if (step === 8 && (!finishes[0] || finishes[0].trim() === "")) {
      return setError("* Finishes field is required.");
    }
    if (step === 9 && (!availableSizes[0] || availableSizes[0].trim() === "")) {
      return setError("* Available Sizes field is required.");
    }
    if (step === 10) {
      const isPdfValid = pdfFile.some((pdf) => pdf.name.trim() !== "" && pdf.file !== null);
      
      if (!isPdfValid) {
        return setError("* PDF Name and PDF Upload are required.");
      }
    }     
    if (step === 11 && (!advantages[0] || advantages[0].trim() === "")) {
      return setError("* Advantages field is required.");
    }

    setError("");
    setStep((prev) => prev + 1);
  };

  const handlePdfUpload = (index, event) => {
    if (!event.target.files.length) return;
  
    const newPdfFile = [...pdfFile];
    newPdfFile[index] = { ...newPdfFile[index], file: event.target.files[0] };
    setPdfFile(newPdfFile);
  };
  




  const handlePreviousStep = () => {
    setError("");
    setStep((prev) => prev - 1);
  };

  const addTitle = () => {
    setTitle((prevTitles) => [...prevTitles, ""]);
  };

  const removeTitle = (index) => {
    if (title.length > 1) {
      setTitle(title.filter((_, i) => i !== index)); // Remove title at index
    }
  };


  const addDescription = () => {
    setDescriptions([...descriptions, ""]);
  };

  const removeDescription = (index) => {
    if (descriptions.length > 1) {
      setDescriptions(descriptions.filter((_, i) => i !== index));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewImage(URL.createObjectURL(file)); // Create preview URL
    }
  };


const handleSubmit = async () => {
  setError("");
  setLoading(true);
  setShowSubmitButton(false);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  const base64Image = image ? await toBase64(image) : "";

  const pdfBase64Array = await Promise.all(
    pdfFile.filter((pdf) => pdf.file).map((pdf) => toBase64(pdf.file))
  );

  const pdfNamesArray = pdfFile.map((pdf) => pdf.name);

  const requestBody = {
    category: selectecatogery,
    subcategory: selectedSubcatogery,
    title: title,
    descriptions: descriptions,
    country: country,
    imageBase64: base64Image,
    performance: performance,
    productVideo: productVideo,
    finishes: finishes,
    availableSizes: availableSizes,
    pdfName: pdfNamesArray,
    pdfBase64: pdfBase64Array,
    advantages: advantages,
  };

  const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

  try {
    const response = await fetch("https://backend.aktcorp.com/product/addproduct", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // ✅ Added Authorization header
      },
      body: JSON.stringify(requestBody),
      mode: "cors",
    });

    const data = await response.json();

    if (response.ok) {
      setTimeout(() => {
        setLoading(false);
        setSuccessMsg("✅ Product added successfully!");

        setTimeout(() => {
          setSuccessMsg("");
          setShowSubmitButton(true);
          setTimeout(() => {
            // window.location.reload(); // ✅ Reload the page
          }, 0);
        }, 5000);
      }, 3000);
    } else {
      setLoading(false);
      setShowSubmitButton(true);
      setError(`❌ Error: ${data.error || "Something went wrong"}`);
    }
  } catch (error) {
    setLoading(false);
    setShowSubmitButton(true);
    setError("❌ Error: Network issue or API down.");
    console.error("API Error:", error);
  }
};

  

//   const resetForm = () => {
//     setSelectedCatogery("");
//     setSelectedSubCatogery("");
//     setTitle([""]);  // ✅ Ensure it's an array
//     setDescriptions([""]);
//     setImage(null);
//     setPdfFile([{ name: "", file: null }]);
//     // setPdfBase64("");  
//     setPerformance([""]);
//     setProductVideo([""]);
//     setFinishes([""]);
//     setAvailableSizes([""]);
//     setAdvantages([""]);
//     setStep(1);
// };



  const addPerformance = () => setPerformance([...performance, ""]);
  const removePerformance = (index) => setPerformance(performance.filter((_, i) => i !== index));

  const addProductVideo = () => setProductVideo([...productVideo, ""]);
  const removeProductVideo = (index) => setProductVideo(productVideo.filter((_, i) => i !== index));

  const addFinishes = () => setFinishes([...finishes, ""]);
  const removeFinishes = (index) => setFinishes(finishes.filter((_, i) => i !== index));

  const addAdvantages = () => setAdvantages([...advantages, ""]);
  const removeAdvantages = (index) => setAdvantages(advantages.filter((_, i) => i !== index));

  const addAvailableSize = () => setAvailableSizes([...availableSizes, ""]);
  const removeAvailableSize = (index) => setAvailableSizes(availableSizes.filter((_, i) => i !== index));

  const addPdf = () => {
    setPdfFile((prev) => [...prev, { name: "", file: null }]);
  };
  
  const removePdf = (index) => setPdfFile((prev) => prev.filter((_, i) => i !== index));

  const updatePdfName = (index, name) => {
    setPdfFile((prev) =>
      prev.map((item, i) => (i === index ? { ...item, name } : item))
    );
  };






  return (
    <div className="max-w-3xl mx-auto bg-white rounded-lg p-6 space-y-6 mt-10 mb-10">
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl font-bold text-gray-900 bg-clip-text text-center mb-4 text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
      >
        Add New Product
      </motion.h2>
      {error && <p className="text-red-500 text-center font-semibold">{error}</p>}

      {/* Form Steps */}
      {step === 1 && (
        <div>
          <label className="block text-lg font-semibold">Choose Category :</label>
          <select className="w-full p-2 border rounded-md" onChange={(e) => setSelectedCatogery(e.target.value)} value={selectecatogery}>
            <option value="">Choose a Category</option>
            {menus.map((catogery) => (
              <option key={catogery} value={catogery}>{catogery}</option>
            ))}
          </select>
          <button onClick={handleNextStep} className="mt-4 w-full bg-blue-500 text-white p-2 rounded-md">Next</button>
        </div>
      )}

      {step === 2 && (
        <div>
          <label className="block text-lg font-semibold">Choose Subcategory :</label>
          <select className="w-full p-2 border rounded-md" onChange={(e) => setSelectedSubCatogery(e.target.value)} value={selectedSubcatogery}>
            <option value="">Choose a Subcategory</option>
            {submenus[selectecatogery]?.map((subcatogery) => (
              <option key={subcatogery} value={subcatogery}>{subcatogery}</option>
            ))}
          </select>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div>
          <label className="block text-lg font-semibold">Upload Image :</label>
          <input type="file" accept="image/*" className="w-full p-2 border rounded-md" onChange={handleImageChange} />
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-500 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>
      )}

      {step === 4 && (
        <div className="mt-4">
          <label className="block text-lg font-semibold">Select Country:</label>
          <select
            className="w-full p-2 border rounded-md"
            value={country}
            onChange={(e) => setSelectedCountry(e.target.value)} // ✅ Correctly update state
          >
            <option value="">Choose a Country</option>
            <option value="All Country">All Country</option>
            <option value="North America">North America</option>
            <option value="Latin America">Latin America</option>
            <option value="Europe, Middle East & Africa">Europe, Middle East & Africa</option>
            <option value="India & Pakistan">India & Pakistan</option>
            <option value="Southeast Asia">Southeast Asia</option>
            <option value="Australia & New Zealand">Australia & New Zealand</option>
            <option value="Japan">Japan</option>
            <option value="China">China</option>
          </select>

          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-500 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>
      )}



      {step === 5 && (
        <div>
          {title.map((t, index) => (
            <div key={index} className="mt-2 relative">
              <label className="block text-lg font-semibold">Product Title {index + 1}:</label>
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter title"
                value={t} // Use 't' instead of 'title'
                onChange={(e) => {
                  const newTitles = [...title];
                  newTitles[index] = e.target.value; // Update only the changed input
                  setTitle(newTitles);
                }}
              />
              {index > 0 && (
                <button
                  onClick={() => removeTitle(index)}
                  className="absolute top-0 right-0 text-red-600 px-2 py-1 rounded-md"
                >
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}

          {/* Button to Add More Titles */}
          <button onClick={addTitle} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">
            Add More Titles
          </button>

          {descriptions.map((desc, index) => (
            <div key={index} className="mt-2 relative">
              <label className="block text-lg font-semibold">Description : {index + 1}</label>
              <textarea
                className="w-full p-2 border rounded-md"
                placeholder="Enter description"
                value={desc}
                onChange={(e) => {
                  const newDescriptions = [...descriptions];
                  newDescriptions[index] = e.target.value;
                  setDescriptions(newDescriptions);
                }}
              />
              {index > 0 && (
                <button
                  onClick={() => removeDescription(index)}
                  className="absolute top-0 right-0 text-red-600 px-2 py-1 rounded-md">
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}

          <button onClick={addDescription} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">Add More Description</button>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>
      )}

      {step === 6 && (
        <div>
          <label className="block text-lg font-semibold">Performance:</label>
          {performance.map((item, index) => (
            <div key={index} className="relative mt-2">
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter Performance"
                value={item}
                onChange={(e) => {
                  let newValues = [...performance];
                  newValues[index] = e.target.value;
                  setPerformance(newValues);
                }}
              />
              {index > 0 && (
                <button onClick={() => removePerformance(index)} className="absolute right-0 text-red-600 px-2 py-1">
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}
          <button onClick={addPerformance} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">
            Add More Performance
          </button>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>



      )}

      {/* // Step 7 - Product Video Input */}
      {step === 7 && (
        <div>
          <label className="block text-lg font-semibold">Product Video URL:</label>
          {productVideo.map((item, index) => (
            <div key={index} className="relative mt-2">
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter Video URL"
                value={item}
                onChange={(e) => {
                  let newValues = [...productVideo];
                  newValues[index] = e.target.value;
                  setProductVideo(newValues);
                }}
              />
              {index > 0 && (
                <button onClick={() => removeProductVideo(index)} className="absolute right-0 text-red-600 px-2 py-1">
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}
          <button onClick={addProductVideo} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">
            Add More Video URL
          </button>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>

      )}

      {/* // Step 8 - Finishes Input */}
      {step === 8 && (
        <div>
          <label className="block text-lg font-semibold">Available Finishes:</label>
          {finishes.map((item, index) => (
            <div key={index} className="relative mt-2">
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter Finishes"
                value={item}
                onChange={(e) => {
                  let newValues = [...finishes];
                  newValues[index] = e.target.value;
                  setFinishes(newValues);
                }}
              />
              {index > 0 && (
                <button onClick={() => removeFinishes(index)} className="absolute right-0 text-red-600 px-2 py-1">
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}
          <button onClick={addFinishes} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">
            Add More Finishes
          </button>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>

      )}

      {/* // Step 9 - Available Sizes Input */}
      {step === 9 && (
        <div>
          <label className="block text-lg font-semibold">Available Sizes:</label>
          {availableSizes.map((item, index) => (
            <div key={index} className="relative mt-2">
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter Available Sizes"
                value={item}
                onChange={(e) => {
                  let newValues = [...availableSizes];
                  newValues[index] = e.target.value;
                  setAvailableSizes(newValues);
                }}
              />
              {index > 0 && (
                <button onClick={() => removeAvailableSize(index)} className="absolute right-0 text-red-600 px-2 py-1">
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}
          <button onClick={addAvailableSize} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">
            Add More Sizes
          </button>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>

      )}
      {step === 10 && (
        <div>
          {pdfFile.map((file, index) => (
            <div key={index} className="relative mb-4 border p-3 rounded-md shadow">

              {/* Delete button in top-right corner */}
              {index > 0 && (
                <button
                  onClick={() => removePdf(index)}
                  className="absolute right-2 top-2 text-red-600"
                >
                  <FaTrash size={18} />
                </button>
              )}

              <label className="block text-lg font-semibold">PDF Name:</label>
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                value={file.name}
                onChange={(e) => updatePdfName(index, e.target.value)}
              />

              <label className="block text-lg font-semibold mt-2">Upload PDF:</label>
              <input
                type="file"
                accept=".pdf"
                className="w-full p-2 border rounded-md"
                onChange={(e) => handlePdfUpload(index, e)}
              />
            </div>
          ))}

          {/* Add More PDF button */}
          <button
            onClick={addPdf}
            className="w-full bg-blue-500 text-white p-2 rounded-md mt-4"
          >
            Add More PDF
          </button>

          <div className="flex justify-between mt-6">
            <button onClick={handlePreviousStep} className="bg-gray-500 text-white p-2 rounded-md">
              Back
            </button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">
              Next
            </button>
          </div>
        </div>
      )}




      {/* // Step 11 - Advantage Input */}
      {step === 11 && (
        <div>
          <label className="block text-lg font-semibold">Advantages:</label>
          {advantages.map((item, index) => (
            <div key={index} className="relative mt-2">
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                placeholder="Enter Advantages "
                value={item}
                onChange={(e) => {
                  let newValues = [...advantages];
                  newValues[index] = e.target.value;
                  setAdvantages(newValues);
                }}
              />
              {index > 0 && (
                <button onClick={() => removeAdvantages(index)} className="absolute right-0 text-red-600 px-2 py-1">
                  <FaTrash size={18} />
                </button>
              )}
            </div>
          ))}
          <button onClick={addAdvantages} className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md">
            Add More Advantage
          </button>
          <div className="flex justify-between mt-4">
            <button onClick={handlePreviousStep} className="bg-gray-400 text-white p-2 rounded-md">Back</button>
            <button onClick={handleNextStep} className="bg-blue-500 text-white p-2 rounded-md">Next</button>
          </div>
        </div>

      )}

      {/* Step 5: Preview Section Before Final Submission */}
      {step === 12 && (
        <div className="bg-[#0c2340] p-5 rounded-lg">
          <div className="flex flex-col bg-white rounded-lg overflow-hidden p-4 duration-300 ease-in-out">
            {/* Image Container with Zoom Effect */}
            <div className="w-full h-[260px] overflow-hidden rounded-md">
              <img
                src={previewImage}
                alt="hello"
                className="w-full h-full object-contain rounded-md"
              />
            </div>
            <div className="flex-grow">
              {title.map((title, index) => (
                <h2 key={index} className="text-2xl md:text-3xl font-semibold py-2">
                  {title}
                </h2>
              ))}
            </div>
            <div>
              {/* <strong>Descriptions:</strong> */}
              {descriptions.length === 1 ? (
                <p className="text-gray-800 font-medium">{descriptions[0]}</p>
              ) : (
                <ul className="list-disc ml-5">
                  {descriptions.map((desc, index) => (
                    <li key={index} className="text-gray-800 font-medium">{desc}</li>
                  ))}
                </ul>

              )}
              <p className="text-gray-800 font-medium">{performance[0]}</p>
              <p className="text-gray-800 font-medium">{performance[1]}</p>

              <p className="text-gray-800 font-medium">{productVideo[0]}</p>
              <p className="text-gray-800 font-medium">{productVideo[1]}</p>

              <p className="text-gray-800 font-medium">{finishes[0]}</p>
              <p className="text-gray-800 font-medium">{finishes[1]}</p>

              <p className="text-gray-800 font-medium">{availableSizes[0]}</p>
              <p className="text-gray-800 font-medium">{availableSizes[1]}</p>

              <p className="text-gray-800 font-medium">{pdfName[0]}</p>

              <p className="text-gray-800 font-medium">{advantages[0]}</p>
              <p className="text-gray-800 font-medium">{advantages[1]}</p>
            </div>

          </div>
          <div className="flex justify-between items-center mt-4">
            {/* ✅ Show Cancel Button always */}


            {/* ✅ Show Spinner when submitting */}
            {loading && (
              <div className="spinner w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto my-4"></div>
            )}

            {/* ✅ Show Success Message after submission */}
            {successMsg && <p className="text-green-500 text-center font-semibold">{successMsg}</p>}

            {/* ✅ Show Upload Button on the right */}

            {showSubmitButton && (
              <>
                <button
                  onClick={handlePreviousStep}
                  className="bg-gray-400 text-white p-2 rounded-md w-1/2 mr-2"
                >
                  Back
                </button>
                <button onClick={handleSubmit} className="bg-blue-500 text-white p-2 rounded-md w-1/2 ml-2">
                  Upload
                </button>
              </>
            )}
          </div>


        </div>
      )}
    </div>
  );
};

export default ProductAdd;
